<template>
  <div>
    <div>
      <h1 class="mb-8 font-bold text-3xl">
        Pembayaran Akhir Studi Mahasiswa
        <span class="font-medium text-indigo-400">/</span>
        {{ mahasiswa.name }}
      </h1>
    </div>
    <div class="overflow-x-scroll bg-white rounded-md shadow">
      <table class="w-full whitespace-nowrap">
        <thead>
          <tr class="font-bold text-left">
            <th class="px-6 pt-6 pb-4 text-left">
              Tanggal Pembayaran
            </th>
            <th class="px-6 pt-6 pb-4 text-left">
              Bank Mahasiswa
            </th>
            <th class="px-6 pt-6 pb-4 text-left">
              Nomor Rekening Mahasiswa
            </th>
            <th class="px-6 pt-6 pb-4 text-left">
              Status Pembayaran
            </th>
            <th class="px-6 pt-6 pb-4 text-right">
              Nominal Pembayaran
            </th>
            <th class="px-6 pt-6 pb-4 text-center">
              Bukti Pembayaran
            </th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="row in eosPayments.data"
            :key="row.id"
            class="focus-within:bg-gray-100 hover:bg-gray-100">
            <td class="py-4 px-6 text-left border-t">
              {{ row.payment_date }}
            </td>
            <td class="py-4 px-6 text-left border-t">
              {{ row.bank }}
            </td>
            <td class="py-4 px-6 text-left border-t">
              {{ row.scholarship_bank_acc_number }}
            </td>
            <td class="py-4 px-6 text-left border-t">
              {{ row.payment_status }}
            </td>
            <td class="py-4 px-6 text-right border-t">
              {{ formatNumber(row.payment_amount) }}
            </td>
            <td class="py-2 px-4 text-center border-t">
              <Link
                @click.prevent="showModal(row.payment_file)"
                class="btn-indigo"
                as="button">
                Lihat
              </Link>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <pagination class="mt-6" :links="eosPayments.links" />
    <modal :is-modal-show="isModalVisible" @close="closeModal">
      <template slot="header">
        {{ modalTextHeader }}
      </template>
      <template slot="body">
        <div class="flex justify-center">
          <blob-image :src="imgUrl" />
        </div>
      </template>
    </modal>
  </div>
</template>

<script>
import Layout from '@/Shared/Layout'
import Pagination from '@/Shared/Pagination'
import Modal from '@/Shared/Modal'
import BlobImage from '@/Shared/BlobImage'
import { Link } from '@inertiajs/vue2'

export default {
  metaInfo: { title: 'Pembayaran Akhir Studi ' },

  layout: Layout,

  components: {
    Pagination,
    Modal,
    BlobImage,
    Link,
  },

  props: {
    eosPayments: Object,
    mahasiswa: Object,
  },

  data () {
    return {
      imgUrl: null,
      isModalVisible: false,
      modalTextHeader: 'Hasil Scan',
    }
  },

  methods: {
    formatNumber (num) {
      return num ? num.toLocaleString('id-ID') : '0'
    },
    showModal (filepath) {
      this.imgUrl = `/preview/${filepath}`
      this.isModalVisible = true
    },
    closeModal () {
      this.isModalVisible = false
    },
  },
}
</script>
